module.exports = __webpack_public_path__ + "static/media/portfolio_detail_2_challenge_img.871499d6.png";